module.exports = __webpack_public_path__ + "img/calendar-4.ab2e4d99.svg";